export default __webpack_public_path__ + "static/media/cbc_logo.dee8a9c8.svg";